import { render, staticRenderFns } from "./UpgradePackagePanel.vue?vue&type=template&id=c00c863e&scoped=true"
import script from "./UpgradePackagePanel.vue?vue&type=script&lang=ts"
export * from "./UpgradePackagePanel.vue?vue&type=script&lang=ts"
import style0 from "./UpgradePackagePanel.vue?vue&type=style&index=0&id=c00c863e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00c863e",
  null
  
)

export default component.exports